<template>
	<div>
		<el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="25vh">
			<freeUserTips :type="4" :bgtype="0"></freeUserTips>
		</el-dialog>
		<dl class="opport-screen bdbe opport-screen-overflow-auto" v-show="showFirstList">
			<dt class="fl">{{ oneLevelTitle }}</dt>
			<dd class="fl screenop" >
				<span @click="beforeChooseNotion(1, 'a', { lable: '全部', value: 0, children: [] })"
					:class="chooseNotionlist[0] === 0 ? 'a-screen current' : 'a-screen'"
					v-show="isShowOneLevelTotal">全部</span>
				<span :key="index" v-for="(item, index) in notionlist"
					:class="{ 'a-screen': true, 'current': chooseNotionlist[0] === item.value, 
					'before-line ml-4': !isStickySimpleNoting && item.value === 'U', 
					'after-line mr-4': isStickySimpleNoting && item.value === 'U', 
					}"
					@click="beforeChooseNotion(1, 'a', item)">{{ item.label }}</span>
				<!-- 搜索框 -->
				<div class="sider-left por" v-if="isShowNotionScreen">
					<div class="area-bar" style="height: 32px;">
						<div class="search-bar">
							<!--  @blur="showSearchResult=false" -->
							<el-input class="search-text" ref="elSearch" clearable prefix-icon="el-icon-search"
								placeholder="请输入产业关键词" v-model="searchWord"></el-input>
							<!-- <button class="search-btn" @click="searchEnterprise"><i slot="suffix"  @keyup.enter.native="searchEnterprise" 	@keyup="searchEnterprise" 
									class="el-input__icon el-icon-search"></i>查询</button> -->
						</div>
					</div>
					<div class="view-bar box-shadow" v-show="showSearchResult">
						<div class="box-card search-result">
							<!-- <div class="header clearfix">
								<span><span class="kw red-font-1">{{ searchWord}}</span> 共搜索到 <span
										class="num">{{ searchList.length }}</span>条概念搜索结果</span>
								<i @click="closeSearchBar" style="float: right; margin-top:5px;" class="el-icon-close"
									type="text"></i>
							</div> -->
							<div class="cont cont2">
								<div class="item" @click="onSelectItem(item)" v-for="(item, index) in searchList"
									:key="index">
									<!-- <strong class="code-f red-font-1">{{item.value}}</strong> -->
									<p class="title" v-html="formatSearchTitle(item.label)"></p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</dd>
		</dl>
		<dl class="opport-screen bdbe" v-show="notionlist1.length > 0 && showLevelNum > 1" :class="{ 'opport-screen-overflow-auto': !showFirstList }">
			<dt class="fl titleop">一级产业</dt>
			<dd class="fl">
				<span @click="beforeChooseNotion(2, 'all', fenkd)" v-show="computedNotionNum && isShowSecondLevelTotal"
					:class="chooseNotionlist[1] == 0 ? 'a-screen current' : 'a-screen'">全部</span>
				<span :key="index" v-for="(item, index) in notionlist1"
					:class="chooseNotionlist[1] == item.value ? 'a-screen current' : 'a-screen'"
					@click="beforeChooseNotion(2, 'a', item)">{{ item.label }}<em class="num"
						v-show="!searchNotionBtn && item.num && item.num > 0">({{ item.num }})</em></span>

				<!-- 搜索框 -->
				<div class="sider-left por" v-if="isShowNotionScreen && !showFirstList">
					<div class="area-bar" style="height: 32px;">
						<div class="search-bar">
							<!--  @blur="showSearchResult=false" -->
							<el-input class="search-text" ref="elSearch" clearable prefix-icon="el-icon-search"
								placeholder="请输入产业关键词" v-model="searchWord"></el-input>
							<!-- <button class="search-btn" @click="searchEnterprise"><i slot="suffix"  @keyup.enter.native="searchEnterprise" 	@keyup="searchEnterprise" 
									class="el-input__icon el-icon-search"></i>查询</button> -->
						</div>
					</div>
					<div class="view-bar box-shadow" v-show="showSearchResult">
						<div class="box-card search-result">
							<!-- <div class="header clearfix">
								<span><span class="kw red-font-1">{{ searchWord}}</span> 共搜索到 <span
										class="num">{{ searchList.length }}</span>条概念搜索结果</span>
								<i @click="closeSearchBar" style="float: right; margin-top:5px;" class="el-icon-close"
									type="text"></i>
							</div> -->
							<div class="cont cont2">
								<div class="item" @click="onSelectItem(item)" v-for="(item, index) in searchList"
									:key="index">
									<!-- <strong class="code-f red-font-1">{{item.value}}</strong> -->
									<p class="title" v-html="formatSearchTitle(item.label)"></p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</dd>
		</dl>
		<dl class="opport-screen bdbe" v-if="notionlist2.length > 0 && showLevelNum > 2">
			<dt class="fl titleop">二级细分</dt>
			<dd class="fl">
				<span @click="beforeChooseNotion(3, 'all', fenkd)" v-show="computedNotionNum"
					:class="chooseNotionlist[2] == 0 ? 'a-screen current' : 'a-screen'">全部</span>
				<span :key="index" v-for="(item, index) in notionlist2"
					:class="chooseNotionlist[2] == item.value ? 'a-screen current' : 'a-screen'"
					@click="beforeChooseNotion(3, 'a', item)">{{ item.label }}<em class="num"
						v-show="!searchNotionBtn && item.num && item.num > 0">({{ item.num }})</em></span>
			</dd>
		</dl>
		<dl class="opport-screen bdbe" v-show="notionlist3 && notionlist3.length > 0 && showLevelNum > 3">
			<dt class="fl titleop">三级细分</dt>
			<dd class="fl">
				<span @click="beforeChooseNotion(4, 'all', fenkd)"
					:class="chooseNotionlist[3] == 0 ? 'a-screen current' : 'a-screen'">全部</span>
				<span :key="index" v-for="(item, index) in notionlist3"
					:class="chooseNotionlist[3] == item.value ? 'a-screen current' : 'a-screen'"
					@click="beforeChooseNotion(4, 'a', item)">{{ item.label }}<em class="num"
						v-show="!searchNotionBtn && item.num && item.num > 0">({{ item.num }})</em></span>
			</dd>
		</dl>
		<dl class="opport-screen bdbe" v-show="notionlist4.length > 0 && showLevelNum > 4">
			<dt class="fl titleop">四级细分</dt>
			<dd class="fl">
				<span @click="beforeChooseNotion(5, 'all', fenkd)"
					:class="chooseNotionlist[4] == 0 ? 'a-screen current' : 'a-screen'">全部</span>
				<span :key="index" v-for="(item, index) in notionlist4"
					:class="chooseNotionlist[4] == item.value ? 'a-screen current' : 'a-screen'"
					@click="beforeChooseNotion(5, 'a', item)">{{ item.label }}</span>
			</dd>
		</dl>
		<!-- <dl class="opport-screen bdbe" v-show="notionlist5.length > ">
			<dt class="fl titleop">四级细分</dt>
			<dd class="fl">
				<span @click="beforeChooseNotion(5, 'all', fenkd)"
					:class="chooseNotionlist[4] == 0 ? 'a-screen current' : 'a-screen'">全部</span>
				<span :key="index" v-for="(item, index) in notionlist4"
					:class="chooseNotionlist[4] == item.value ? 'a-screen current' : 'a-screen'"
					@click="beforeChooseNotion(5, 'a', item)">{{ item.label }}</span>
			</dd>
		</dl> -->
	</div>
</template>
<script>
export default {
	name: 'zpagenav',
	data() {
		return {
			userdata: {},
			title: "概念的展示与搜索",
			notiontext: '',
			notionCode: '0',
			chooseNotionlist: [0, 0, 0, 0, 0],
			chooseNotionTextlist: ['', '', '', '', '', ''],
			notionlistDefault: [],
			notionStep: 1,
			notionlist: [],
			notionlist1: [],
			notionlist2: [],
			notionlist3: [],
			notionlist4: [],
			notionlist5: [],
			notionlist6: [],
			fenkd: {
				children: []
			},
			//概念搜索专用
			searchWord: '',
			showSearch: true,
			showSearchResult: false,
			searchList: [],
			searchTimerId: 0,
			viewList: [],
			searchNotionBtn: false,
			computedNotionNum: true,
			notionExted: [0, 0, 0, 0, 0],//重点企业用来存用户选中的概念
			matchedItems: {},
			isShowSecondLevelTotal: true,
			tempLinkCode: '',
			isShowFreeUserTips:false,
		}
	},
	watch: {
		searchWord() {
			this.searchEnterprise();
		},

		notionNumberList: {
			handler(newValue, oldValue) {
				console.log('notionNumberList', newValue);
				if(this.ucomputer){
					return;
				}
				this.notionNumberList = newValue;
				this.setnotionNumlist(this.notionNumberList);
			}
		},
		notionlistDefault: {
			handler(newValue, oldValue) {
				// console.log('默认notionlistDefault', newValue);
				// this.setnotionNumlist(this.notionNumberList);
			}
		},
		showNotionCodeList: {
			handler(newValue, oldValue) {
				this.showNotionCodeList = newValue;
			}
		},
		isIntegration: {
			handler(newval) {
				console.log('isIntegration', newval);
				this.notionlist = this.setIsIntegration(this.notionlist);
			}
		},
		refreshNum: {
			handler(newval, oldval) {
				this.refreshNum = newval;
				// alert('refreshNum'+this.refreshNum);
				setTimeout(() => { //因为showNotionCodeList返回需要时间，所以延时一下才能拿到最新的值
					if (this.showNotionCodeList && !(Object.keys(this.showNotionCodeList).length === 0)) {
						this.filterNotionList(this.notionlistDefault, this.showNotionCodeList).then((res) => {
							this.notionlist = res;
							this.notionlist1 = this.notionlist[0].children;
							if (this.isClearNotion) {
								this.clearNotionResult();
							}
						});

					}
				}, 300)
				if (this.isClearNotion) {
					this.clearNotionResult();
				}

			}
		},
	},
	props: {
		type: { type: Number, default: 1 }, //入口 1 为后台获取数据 2为列表页获取数据后存入数据 会有数字
		notionNumberList: { type: Array }, //type=2时传入的概念数字列表
		refreshNum: { type: Number, default: 1, },//部分筛选项需要带数字排序 刷新数字 
		isShowNotionScreen: { type: Boolean, default: false, },//是否展示概念搜索框
		token: { type: String, default: "" },
		isClearNotion: { type: Boolean, default: false },//全部企业概念搜索城市时需要还原概念筛选
		oneLevelTitle: { type: String, default: '产业分类' },//产业分类的标题文字
		isShowOneLevelTotal: { type: Boolean, default: true },//是否展示产业分类的全部选项
		showLevelNum: { type: Number, default: 5 },//细分的等级
		isShowManufacturing: { type: Boolean, default: false },//是否只显示先进制造业，用于只展示先进制造业的场景
		showNotionExtend: { type: Boolean, default: false },//是否显示重点产业
		showNotionCodeList: {}, //是否只展示有概念的产业，传入概念字典匹配，目前只有产业数据库需要匹配
		isIntegration: { type: Boolean, default: false },//是否把一二三产集合到一级（传统产业），目前只有企业库需要匹配
		isShowFutureIndustries: { type: Boolean, default: false },//是否显示未来产业，目前只有企业库显示，其他都不显示
		linkNotionCode: { type: String, default: '' },//从产业链详情页跳转到产业库带的概念code，需要定位到对应的概念
		ucomputer:{type:Boolean,default:false},//不计算概念数量，全部企业的港，美股没数据暂时不计算
		showSimpleNotion:{type:Boolean,default:false},//是否显示简易版重点产业的概念的概念列表
		defaultSelected:{type:String,default:''},//默认选中的概念筛选项（简易版页面需要用到）
		showFirstList:{type:Boolean,default:true},//是否展示第一级产业列表
		isStickySimpleNoting:{type:Boolean,default:false},//前置重点产业
	},
	created() {
		this.userdata = this.getuseriformation();
		this.ajaxGetNotionList();
	},
	mounted() {
		
	},
	methods: {
		setIsIntegration(notionArray) {
			console.log('整合产业', notionArray);
			let tempData = { label: '传统产业', value: 'DEF', parentList: ['DEF'], children: [] };
			let newTree = [];
			if (this.isIntegration) {
				notionArray.forEach((item, i) => {
					// console.log('item', item.label);
					if (item.label == '第一产业' || item.label == '第二产业' || item.label == '第三产业') {
						tempData.children.push(item);
						newTree[0] = tempData;
					}
					if (item.label == '先进制造业') {
						item.label = '战略性新兴产业';
						newTree[1] = item;
					}
					if (item.label == '未来产业') {
						newTree[2] = item;
					}
				});
			}
			// notionArray[0] = newTree;
			console.log('整合产业111', newTree);
			return newTree;
		},
		//产业数据库只展示有数据的概念
		filterNotionList(notionArray, dict) {
			return new Promise((resolve, reject) => {
				// console.log('notionArray', notionArray);
				if (Object.keys(dict).length == 0) { //如果字典里面没有直接返回
					notionArray = notionArray.filter(item => {
						return item.label != '未来产业';
					});
					resolve(notionArray);
					// return notionArray;
				}
				const newTree = [];

				// 递归函数，用于检查并保留匹配的节点  
				function traverse(node) {
					if (node.value in dict) { // 检查当前节点的value是否在dict中  
						const newNode = { ...node }; // 创建一个新节点，以避免直接修改原始节点  
						if (node.children) {
							newNode.children = node.children.filter(child => traverse(child)); // 递归检查子节点  
						}
						return newNode; // 返回匹配的节点  
					}
					// 如果当前节点不匹配且它有子节点，则递归检查子节点  
					// 但是，由于我们只关心匹配的节点，所以这里不返回任何内容（即false）  
					if (node.children) {
						const filteredChildren = node.children.filter(child => traverse(child));
						// 如果任何子节点匹配，我们可能想要保留这个节点（取决于你的具体需求）  
						// 但为了简单起见，这里我们假设我们只关心直接匹配的节点  
						// 你可以根据需要调整这部分逻辑  
					}
					return false; // 当前节点不匹配  
				}

				// 遍历notionlist中的每个顶级节点  
				notionArray.forEach(rootNode => {
					const newNode = traverse(rootNode);
					if (newNode) { // 如果顶级节点或其子节点匹配，则添加到新树中  
						newTree.push(newNode);
					}
				});
				// this.notionlist = newTree;
				console.log('筛选后的结果', newTree); // 输出结果
				resolve(newTree);
				// return newTree;
			});

		},

		beforeChooseNotion(step, type, data, index) {
			if(!this.userdata.token){
				this.isShowFreeUserTips = true;
				return;
			}
			console.log('beforeChooseNotion', step, type, data, index);
			if (this.showNotionCodeList && !(Object.keys(this.showNotionCodeList).length === 0)) {
				this.filterNotionList(this.notionlistDefault, this.showNotionCodeList).then((res) => {//要等筛选完成再去赋值，否则notionlist1会是原来的值
					this.chooseNotion(step, type, data, index);
				});

			} else {
				this.chooseNotion(step, type, data, index);
			}
		},
		getSimpleNotionList() {
			var _this = this;
			this.$axios.get(this.$api.cyl.usercenter.investNotion(), {
				headers: {
					AuthToken: this.token
				}
			}).then(function (res) {
				// console.log('简易版重点产业', res);
				if (res.data.success) {
					let temNotionList = res.data.list;
					//递归把temNotionList中包括子集的数据，name改为label，code改为value
					 
					
					let testNostion={};
					testNostion.children=temNotionList;
					testNostion.level=0;
					testNostion.label='重点产业';
					testNostion.value='U';
					testNostion.parentList=['U'];
					testNostion.relatedCode='';
					testNostion = _this.transformData(testNostion);
					let firstChild = testNostion.children;
					for (let i = 0; i < firstChild.length; i++) {
						firstChild[i].value	 = 'U'+firstChild[i].name;
					}
					if(_this.showFirstList){
						_this.isStickySimpleNoting?_this.notionlist.unshift(testNostion):_this.notionlist.push(testNostion);
					}else{
						_this.notionlist = [testNostion];
					}
					if(_this.defaultSelected == 'simpleNotion'){
						
						console.log('默认简易版重点产业beforeChooseNotion', testNostion);
						_this.beforeChooseNotion(1, 'a', testNostion, 0);
					}
					
					_this.notionlistDefault.push(testNostion);
					console.log('简易版重点产业notionlist', _this.notionlist);
				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		//处理简易版重点产业数据
		transformData(obj) {
			if (Array.isArray(obj)) {
				// 如果是数组，递归处理每一项
				return obj.map(item => this.transformData(item));
			} else if (typeof obj === 'object' && obj !== null) {
				// 如果是对象
				if ('name' in obj) {
					obj.label = obj.name;  // 添加或覆盖 label 字段
				}
				if ('code' in obj) {
					obj.value = obj.code;  // 添加或覆盖 value 字段
					obj.relatedCode = obj.code;
					obj.iskeyNotion = true;
				}

				// 递归处理子对象
				for (let key in obj) {
					if (typeof obj[key] === 'object' && obj[key] !== null) {
						obj[key] = this.transformData(obj[key]);
					}
				}

				return obj; // 返回修改后的对象
			}

			// 如果是其他类型，直接返回
			return obj;
		},
		//获取重点产业数据
		getNotionExtend() {
			var _this = this;
			this.$axios.get(this.$api.tag.notionExtend.list(), {
				headers: {
					AuthToken: this.token
				}
			}).then(function (res) {
				console.log('重点产业', res);
				if (res.data.success) {
					let notionExtendList = res.data.list;
					console.log('notionExtendList', notionExtendList);
					notionExtendList.forEach((list) => {
						list.parentList = [list.value];
						_this.notionlist.push(list);
						_this.notionlistDefault.push(list);
					})
				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		//三大产业概念数据
		ajaxGetNotionList() {
			var _this = this;
			this.$axios.get(this.$api.tag.notion.list() + '?level=6', {
				headers: {
					AuthToken: this.token
				}
			}).then(function (res) {
				console.log('三大产业概念数据', res);
				if (res.data.success) {
					_this.notionlist = res.data.list;
					_this.notionlistDefault = res.data.list;
					
					for (var i = 0; i < _this.notionlist.length; i++) {
						_this.notionlist[i].parentList = [_this.notionlist[i].value];
						if (_this.notionlist[i].value == 'A') {
							_this.notionlist[i].children = _this.notionlist[i].children.filter(lists => {
								return lists.label != '环保';
							})
						}
					}
					if(_this.linkNotionCode != '' && _this.linkNotionCode){ 
						console.log('linkNotionCode',_this.linkNotionCode)
						_this.filterTree(_this.linkNotionCode,_this.notionlistDefault,2).then((res) => {
							console.log('筛选后的结果', res,_this.linkNotionCode);
							_this.onSelectItem(_this.tempLinkCode);
						})
					}
					if (!_this.isShowFutureIndustries) {
						_this.notionlist = _this.notionlist.filter((list => {
							return list.label.indexOf('未来') < 0;
						}))
					}

					if (_this.isShowManufacturing) { //只显示制造业
						_this.notionlist = _this.notionlist.filter((list => {
							return list.label == '先进制造业';
						}))
					}
					if (_this.isIntegration) { //把一二三产放到传统产业下面
						_this.notionlist = _this.setIsIntegration(_this.notionlist);
					}
					_this.chooseNotionlist = _this.isShowOneLevelTotal ? [0, 0, 0, 0, 0] : ['A', 0, 0, 0, 0, 0];
					_this.notionCode = _this.isShowOneLevelTotal ? 0 : 'A'; 

					if (_this.showNotionCodeList && !(Object.keys(_this.showNotionCodeList).length === 0)) {
						_this.filterNotionList(_this.notionlistDefault, _this.showNotionCodeList).then((res) => {
							// _this.notionlist = res;
						});
					}
					_this.notionlist1 = _this.isShowOneLevelTotal ? [] : _this.notionlist[0].children;
					console.log('this.notionlist', _this.notionlist, _this.notionlist1);
					if (_this.showNotionExtend) {
						_this.getNotionExtend();
					}
					if(_this.showSimpleNotion){
						_this.getSimpleNotionList();
					}
				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},

		//根据code长度排序
		sortCodeLength(array) {    				//正序从小到大
			return array.sort(function (a, b) {
				var x = a.value.length;
				var y = b.value.length;
				return ((x < y) ? -1 : (x > y) ? 1 : 0)
			})
		},
		//概念单选 层级显示    
		chooseNotion(step, type, data, index) {
			console.log('概念单选', step, type, data, this.chooseNotionlist);
			//|| this.chooseNotionlist.indexOf('U') > -1
			if (data.value && ((data.value.indexOf('U') > -1) || data.iskeyNotion)) { //判断是否重点产业，如果是就不计算数量，因为重点产业现在没数量
				this.computedNotionNum = false; //用来是否显示 全部
				this.fenkd = {value:'U',children:[]}; //避免点击重点产业三四级全部的时候误导程序以为是非重点产业	
			} else {
				this.computedNotionNum = true;
				this.fenkd = {children:[]};	
			}
			// console.log('computednoiton',this.computedNotionNum,this.chooseNotionlist);
			var siblingsList = [];
			this.notionStep = step;
			this.searchNotionBtn = false;
			if (type == 'all') {
				if (this.computedNotionNum) {
					this.notionCode = this.chooseNotionlist[step - 2];
				} else {
					this.notionCode = this.notionExted[step - 2];
				}
				this.notiontext = this.chooseNotionTextlist[step - 2];
				this.chooseNotionlist[step - 1] = '0';
				this.notionExted[step - 1] = 0;
				this.chooseNotionTextlist[step - 1] = '';
				// console.log('all',this.notionCode,this.notiontext,this.chooseNotionlist,this.chooseNotionTextlist);
			} else {
				this.chooseNotionlist[step - 1] = data.value;
				this.chooseNotionTextlist[step - 1] = data.label;
				for (var i = 0; i < this.chooseNotionlist.length; i++) {
					if (i > step - 1) {
						this.chooseNotionlist[i] = '0';
						this.chooseNotionTextlist[i] = '';
					}
				}
				if (this.computedNotionNum) {
					this.notionCode = data.value;
					if (this.isIntegration && step == 1 && data.value == 'DEF') { //整合后的概念以点击传统产业要选中第一个子集
						this.notionCode = data.children[0].value;
						this.chooseNotionlist[step] = data.children[0].value;
						this.chooseNotionTextlist[step] = data.children[0].label;
						this.notionlist2 = data.children[0].children;
						this.isShowSecondLevelTotal = false; //不显示二级概念的全部选项
					} else {
						if (data.value && data.value.indexOf('D') < 0 && data.value.indexOf('E') < 0 && data.value.indexOf('F') < 0) {
							this.isShowSecondLevelTotal = true;
						}
					}
				} else { //重点产业需要上传的数据是relatedCode要判断一下
					this.notionExted[step - 1] = data.relatedCode;
					this.notionCode = data.relatedCode;
					if (step < 3) { //重点产业大分类没绑定数据，点击大分类直接到二级
						this.chooseNotionlist[step] = data.children[0].value;
						this.chooseNotionTextlist[step] = data.children[0].label;
						this.notionExted[step] = data.children[0].relatedCode;
						if (step == 1) {
							this.notionlist2 = [];
							this.notionCode = data.children[0].children[0].relatedCode;
							this.chooseNotionlist[step + 1] = data.children[0].children[0].value;
							this.chooseNotionlist[step + 2] = 0;
							this.notionExted[step + 1] = data.children[0].children[0].relatedCode;
							this.notionExted[step + 2] = 0;
							this.chooseNotionTextlist[step + 1] = data.children[0].children[0].label;
							this.chooseNotionTextlist[step + 2] = 0;
							this.notionlist2 = data.children[0].children;
							this.notionlist3 = data.children[0].children[0].children;

						} else if (step == 2) {
							this.notionCode = data.children[0].relatedCode;
							this.notionlist3 = data.children[0].children;

						}
					}

				}
				this.notiontext = data.label;
				// console.log('notionExted',this.notionExted,this.chooseNotionlist,this.chooseNotionTextlist)
			}
			
				console.log(this.computedNotionNum);
				if (step == 1&& data.children != null ) {
						this.notionlist1 = data.children.filter(list => {
							return list.label != '环保';
						});
						if (this.computedNotionNum) { //判断一下是否重点产业，非重点产业就清空
							console.log('isIntegration', this.isIntegration, data.value);
							if (data.value != 'DEF') {
								console.log('非传统产业');
								this.notionlist2 = [];
							}
							this.notionlist3 = [];
						}
						this.notionlist4 = [];
				} else if (step == 2) {
					this.notionlist2 = data.children;
					if (this.computedNotionNum) {
						this.notionlist3 = [];
					}
					this.notionlist4 = [];
				} else if (step == 3) {
					this.notionlist3 = data.children;
					this.notionlist4 = [];
				} else if (step == 4) {
					this.notionlist4 = data.children || [];
					this.notionlist5 = [];
				} else if (step == 5) {
					this.notionlist5 = data.children;
				}
			
			// console.log(this.chooseNotionlist); 
			this.closeSearchBar();
			console.log('传给父组件后最后的notioncode', this.chooseNotionlist, this.notionCode, step, this.notiontext);
			this.$emit('chooseNotion', this.chooseNotionlist, this.notionCode, step, this.notiontext);
		},
		//选中搜索后的概念
		onSelectItem(data) {
			console.log('选中搜索后的概念', data);
			if (data.value.indexOf('U') > -1) { //判断是否重点产业下
				this.notionCode = data.relatedCode;
			} else {
				this.notionCode = data.value;
			}
			this.notiontext = data.label;
			this.chooseNotionlist = data.parentList;
			this.searchNotionBtn = true;
			for (var i = 0; i < data.parentList.length - 1; i++) {
				console.log('prar----', data.parentList[i])
				this.slideNotionList(i + 1, data.parentList[i]);
			}
			// this.showSearchResult=false;
			this.closeSearchBar();
			this.$emit('chooseNotion', this.chooseNotionlist, this.notionCode, null, this.notiontext);
		},
		//筛选概念后逐层打开  层级显示
		slideNotionList(step, parentcode) {
			console.log('打开层级', step, parentcode);
			if (step == 1) {
				console.log(this.notionlistDefault);
				var list2 = this.notionlist.filter(list => {
					return list.value == parentcode;
				});
				this.notionlist1 = list2[0].children;
				// console.log(this.notionlist1)
				this.notionlist2 = [];
				this.notionlist3 = [];
				this.notionlist4 = [];
			} else if (step == 2) {
				var list2 = this.notionlist1.filter(list => {
					return list.value == parentcode;
				});
				this.notionlist2 = list2[0].children;
				this.notionlist3 = [];
				this.notionlist4 = [];
			} else if (step == 3) {
				var list2 = this.notionlist2.filter(list => {
					return list.value == parentcode;
				});
				this.notionlist3 = list2[0].children;
				this.notionlist4 = [];
			} else if (step == 4) {
				var list2 = this.notionlist3.filter(list => {
					return list.value == parentcode;
				});
				this.notionlist4 = list2[0].children;
				this.notionlist5 = [];
			} else if (step == 5) {
				var list2 = this.notionlist4.filter(list => {
					return list.value == parentcode;
				});
				this.notionlist5 = list2[0].children;
			}
			// console.log(this.chooseNotionlist);

		},
		//概念搜索 
		searchEnterprise(kw) {
			// clearTimeout(this.searchTimerId); 
			this.showSearchResult = this.searchWord != '';
			console.log('搜索的词', this.searchWord, this.notionlist);
			if (this.showSearchResult) {
				this.searchList = [];
				// this.searchList = this.list.filter(x => x.title.indexOf(kw) >= 0);
				if(this.isIntegration){  //企业列表整合一二三产后一二三产变二级，所以要吧新加的一级加进去
					this.filterTree(this.searchWord, this.notionlist,1);
				}else {
					this.filterTree(this.searchWord, this.notionlistDefault,1);
				}
				this.searchList = this.sortCodeLength(this.searchList);
				console.log('拼接的搜索信息', this.searchList)
			}
		},
		// 递归搜索方法
		filterTree(val, tree,type, newArr = []) {
			return new Promise((resolve, reject) => {
				// console.log(val,tree,type);
			if (!(tree.length && val)) { // 如果搜索关键字为空直接返回源数据
				return tree
			}
			for (let item of tree) {
				if (item.label.indexOf(val) > -1 && type ==1) { // 匹配到关键字的逻辑
					newArr.push(item) // 如果匹配到就在数值中添加记录 
					continue // 匹配到了就退出循环了此时如果有子集也会一并带着 
				}else if(item.value == val && type ==2){ // 产业链详情回跳转到产业库页面，要定位到想通的概念
					// console.log('item-----', item);
					this.tempLinkCode = item; // 如果匹配到就在数值中添加记录
					continue // 匹配到了就退出循环了此时如果有子集也会一并带着 
				}
				if (item.children && item.children.length) { // 如果父级节点没有匹配到就看看是否有子集，然后做递归 
					for (let smitem of item.children) {
						smitem.parentList = [smitem.value];
						// console.log('smitem',smitem.parentList);
						if (item.parentList) {
							// smitem.parentList=item.parentList.push(item.value); 
							smitem.parentList = item.parentList.concat(smitem.parentList);
						}
					}
					// console.log('item.children', item.children);
					let subArr = this.filterTree(val, item.children,type) // 缓存递归后的子集数组 
					// console.log('subArr', subArr);
					if (subArr && subArr.length) { // 如果子集数据有匹配到的节点 
						console.log('item', item);
						let node = {
							...item,
							children: subArr
						} // 关键逻辑，缓存父节点同时将递归后的子节点作为新值 
						newArr.push(node) // 添加进数组 
					}
				}
			}
			// console.log('fasdlfj l=+++++++++++++',this.tempLinkCode);
			if (newArr.length > 0) {
				this.searchList = this.searchList.concat(newArr);
				console.log('newArr', newArr, this.searchList);
			}
			resolve(true);
			})
			
		},
		//后台将有数量的概念传回来后需要和当前的概念列表进行穿插
		setnotionNumlist(citynotionlist) {
			console.log('citynotionlist后台传回来的数量', citynotionlist, this.notionStep)
			if (!this.computedNotionNum || (this.notionStep > 4 && !this.isShowSecondLevelTotal)) { //第二级才计算 或者 重点产业不计算
				return;
			}
			var zancunNlist = [], citynotionlist1 = [];
			if (this.notionStep == 1) {
				if (this.isIntegration && !this.isShowSecondLevelTotal) {
					zancunNlist = this.notionlist2;
				} else {
					zancunNlist = this.notionlist1;
				}
			} else if (this.notionStep == 2) {
				zancunNlist = this.notionlist2;
			} else if (this.notionStep == 3) {
				zancunNlist = this.notionlist3;
			}
			console.log(zancunNlist, this.notionlist1, this.notionlist2, this.notionlist3, this.notionlist4)
			for (var i = 0; i < citynotionlist.length; i++) {
				for (var d = 0; d < zancunNlist.length; d++) {
					// console.log('citynotionlist[i].notionCode',citynotionlist[i],zancunNlist[d]);
					if (citynotionlist[i].notionCode == zancunNlist[d].value) {
						citynotionlist[i].children = zancunNlist[d].children;
						citynotionlist[i].label = zancunNlist[d].label;
						citynotionlist[i].value = zancunNlist[d].value;
						// console.log('citynotionlist[i].notionCode',citynotionlist[i]);
						citynotionlist1.push(citynotionlist[i]);
						break;
					}
				}
			}
			// console.log('计算后的结果',zancunNlist,citynotionlist,citynotionlist1) 
			if (this.notionStep == 1) {
				if (this.isIntegration && !this.isShowSecondLevelTotal) {
					this.notionlist2 = citynotionlist1;
				} else {
					this.notionlist1 = citynotionlist1;
				}
			} else if (this.notionStep == 2) {
				if (this.isIntegration && !this.isShowSecondLevelTotal) {
					this.notionlist2 = citynotionlist1;
					console.log('citynotionlist2', citynotionlist1)
				} else {
					this.notionlist2 = citynotionlist1;
				}
			} else if (this.notionStep == 3) {
				console.log('第三部');
				this.notionlist3 = citynotionlist1;
				// console.log('notionlist3',this.notionlist3)

			}
		},
		//将搜索标题变红  
		formatSearchTitle(title) {
			return title.replace(this.searchWord, '<span class="red-font-1">' + this.searchWord + '</span>');
		},
		//清空搜索内容 关闭搜索框
		closeSearchBar() {
			this.showSearch = false;
			this.showSearchResult = false;
			this.searchWord = '';
			this.searchList = [];
			// this.setViewList();
		},
		//清空已选概念 
		clearNotionResult() {
			console.log('清空概念');
			this.chooseNotionlist = this.isShowOneLevelTotal ? [0, 0, 0, 0, 0] : ['A', 0, 0, 0, 0, 0];
			this.notionCode = this.isShowOneLevelTotal ? 0 : 'A';
			this.notionlist1 = this.isShowOneLevelTotal ? [] : this.notionlist[0].children;

			// this.notionlist1 = [];
			this.notionlist2 = [];
			this.notionlist3 = [];
			this.notionlist4 = [];
			this.notionlist5 = [];
			// this.notionCode = 0;
			// this.chooseNotionlist = [0, 0, 0, 0, 0, 0];
		},
		// enterSearchIcon() {
		// 	//console.log('enter');
		// 	this.showSearch = true;
		// 	setTimeout(() => {
		// 		this.$refs.elSearch.focus();
		// 	}, 500);
		// },
		// leaveSearchIcon() {
		// 	//console.log('leave');
		// 	this.showSearch = this.showSearchResult || false;
		// },
		// toggleViewbar() {
		// 	this.showViewbar = !this.showViewbar;
		// },
		// setViewList() {
		// 	if (!this.list || this.length == 0 || this.showSearchResult) {
		// 		return;
		// 	}
		// 	//var mapUtil = this.$refs.bgmap.getMapUtil();
		// 	this.viewList = this.mapUtil.getViewList(this.list);
		// 	this.$refs.bgmap.setData(this.viewList);
		// 	this.changePage(1);
		// 	this.mapTotal = this.viewList.length;
		// },
		// changePage(page) {
		// 	this.mapPage = page;
		//  var start = (page - 1) * this.mapPageSize;
		// 	var end = start + this.mapPageSize;
		// 	this.mapPageList = this.viewList.filter((o, i) => i >= start && i < end);
		// 	//console.log(this.pageList);
		// },
		// setSearchList() {
		// 	this.$refs.bgmap.setSearchData(this.searchList);
		// },
	},

}
</script>

<style lang="scss" scoped>
.sider-left {
	float: left;
	font-size: 14px;
	text-align: left;
	width: 380px;
	color: #000;
}

.area-bar {
	padding: 0 10px;
	position: relative;

	.count {
		margin: 0 10px;
	}

	.search-icon {
		float: right;
		margin-top: 7px;
		margin-right: 6px;
		font-size: 18px;

		&:hover {
			color: #39f;
		}
	}

	.el-icon-close {
		font-size: 18px;
	}

	.el-input__icon.el-icon-search {
		width: 18px;
		color: #5E83CC;
	}

	.search-bar {
		position: absolute;
		left: 0;
		top: 0;
		width: 98%;
		height: 100%;

		//display:none;
		.search-text {
			margin: 5px 4px;
			width: 300px;
		}

		.search-btn {
			width: 60px;
			color: #5E83CC;

		}
	}
}

.view-bar {
	position: absolute;
	left: 4px;
	top: 44px;
	width: 300px;
	height: auto;
	z-index: 10;
	background: #fff;

	.box-card {
		.header {
			padding: 15px 20px;
		}

		.cont {
			padding: 5px 0;
			border-top: 1px solid #eee;
			height: 300px;
			overflow-y: scroll;

			.item {
				cursor: default;
				padding: 10px 20px;
				overflow: hidden;
				cursor: pointer;

				&:hover {
					background: #eee;
				}
			}

			.code-f {
				float: left;
				width: 80px;
			}

			.title {
				width: 100%;
				height: auto;
			}

			// .active {
			// 	background: #eee; 
			// 	.title {
			// 		color: #f50;
			// 	}
			// }
		}

		.title {
			font-size: 16px;
			font-weight: bold;
			color: rgba(9, 22, 49, 0.842);
		}

		.addr {
			font-size: 12px;
			color: #555;
			border-bottom: 1px solid #eee;
			padding: 5px 0 10px;
		}
	}

	.pagination {
		padding: 10px 0;
	}
}
</style>